import { FontSize100, FontSize600 } from "@nxt-costco-com/forge-design-tokens";
const COMPONENT_NAME = "Skeleton";
const HIDDEN_TEXT_DEFAULT = "Loading";
const BORDER_RADIUS_STANDARD = "8px";
const BORDER_RADIUS_CIRCLE = "100px";
const CHECKBOX_SIZE = "20px";
const CHECKBOX_CHECK_ID = `${COMPONENT_NAME}-checkbox-check`;
const CHECKBOX_LABEL_ID = `${COMPONENT_NAME}-checkbox-label`;
const NUMBERED_STEP_TITLE_HEIGHT = FontSize600;
const NUMBERED_STEP_DESCRIPTION_HEIGHT = FontSize100;
const NUMBERED_STEP_CIRCLE_ID = `${COMPONENT_NAME}-numbered-step-circle`;
const NUMBERED_STEP_TITLE_ID = `${COMPONENT_NAME}-numbered-step-title`;
const NUMBERED_STEP_DESCRIPTION_ID = `${COMPONENT_NAME}-numbered-step-description`;
const RADIO_BUTTON_CIRCLE_SIZE = "20px";
const RADIO_BUTTON_LABEL_HEIGHT = FontSize100;
const RADIO_BUTTON_CIRCLE_ID = `${COMPONENT_NAME}-radio-button-circle`;
const RADIO_BUTTON_LABEL_ID = `${COMPONENT_NAME}-radio-button-label`;
const MAX_LINES = 50;
export {
  BORDER_RADIUS_CIRCLE,
  BORDER_RADIUS_STANDARD,
  CHECKBOX_CHECK_ID,
  CHECKBOX_LABEL_ID,
  CHECKBOX_SIZE,
  COMPONENT_NAME,
  HIDDEN_TEXT_DEFAULT,
  MAX_LINES,
  NUMBERED_STEP_CIRCLE_ID,
  NUMBERED_STEP_DESCRIPTION_HEIGHT,
  NUMBERED_STEP_DESCRIPTION_ID,
  NUMBERED_STEP_TITLE_HEIGHT,
  NUMBERED_STEP_TITLE_ID,
  RADIO_BUTTON_CIRCLE_ID,
  RADIO_BUTTON_CIRCLE_SIZE,
  RADIO_BUTTON_LABEL_HEIGHT,
  RADIO_BUTTON_LABEL_ID
};
